import { FilterName } from 'types/enums';

// SEO url like /instruments/vocal applied filters to the search
// We have to navigate back to Browse page if the filters corresponding to the routes is removed
const getUpdatedPathname = ({
    pathname,
    browsePath,
    searchParams,
    instrumentsFromRoute,
    genresFromRoute,
    sfxsFromRoute,
}: {
    pathname: string;
    browsePath: string;
    searchParams: URLSearchParams;
    instrumentsFromRoute?: string;
    genresFromRoute?: string;
    sfxsFromRoute?: string;
}): string => {
    const hasNoSlug =
        !instrumentsFromRoute && !genresFromRoute && !sfxsFromRoute;

    const isInstrumentsFromRouteInSearchParams =
        !!instrumentsFromRoute &&
        searchParams
            .getAll(FilterName.Instruments.toLowerCase())
            ?.includes(instrumentsFromRoute);

    if (isInstrumentsFromRouteInSearchParams) {
        const filterKey = FilterName.Instruments.toLowerCase();
        const tags = searchParams
            .getAll(filterKey)
            .filter((tag) => tag !== instrumentsFromRoute);

        searchParams.delete(filterKey);
        for (const tag of tags) searchParams.append(filterKey, tag);
    }

    const isGenresFromRouteInSearchParams =
        !!genresFromRoute &&
        searchParams
            .getAll(FilterName.Genres.toLowerCase())
            ?.includes(genresFromRoute);

    if (isGenresFromRouteInSearchParams) {
        const filterKey = FilterName.Genres.toLowerCase();
        const tags = searchParams
            .getAll(filterKey)
            .filter((tag) => tag !== genresFromRoute);

        searchParams.delete(filterKey);
        for (const tag of tags) searchParams.append(filterKey, tag);
    }

    const isSfxsFromRouteInSearchParams =
        !!sfxsFromRoute &&
        searchParams
            .getAll(FilterName.Sfxs.toLowerCase())
            ?.includes(sfxsFromRoute);

    if (isSfxsFromRouteInSearchParams) {
        const filterKey = FilterName.Sfxs.toLowerCase();
        const tags = searchParams
            .getAll(filterKey)
            .filter((tag) => tag !== sfxsFromRoute);

        searchParams.delete(filterKey);
        for (const tag of tags) searchParams.append(filterKey, tag);
    }

    const isValidPathname =
        hasNoSlug ||
        isInstrumentsFromRouteInSearchParams ||
        isGenresFromRouteInSearchParams ||
        isSfxsFromRouteInSearchParams;

    return isValidPathname ? pathname : browsePath;
};

export default getUpdatedPathname;
